<template>
    <div class="w-100 p-0 d-flex flex-column h-100">
        <div id="hero" class="d-flex justify-content-center align-items-center ">
            <div id="blue-circle">
                <img id="hero-img"  src="crimetimeloginimage3.png" alt="CrimeTimeSimpleView" style="scale: 1.1">
            </div>
        </div>
        <div id="light-blue" class=" d-flex justify-content-center">
            <div class="d-flex flex-column col-10 justify-content-between">
                <div></div>
                <div class="d-flex flex-column w-100">
                    <!-- <h1 class="fw-bold fs-2">What's New?</h1>
                    <span class="fs-6"> Last updated: 8/11/25 </span>
                    <span> </span>
                    <ul class="fs-5 mt-0"> 
                        <li><br> </li>
                    <li></li>
                    <li> </li>
                  </ul> -->
                </div>
                
                <div class="d-flex  w-100 justify-content-evenly ">
                    <div class="col-1"></div>
                    <div class="d-flex flex-column">
                        <h1 class="fw-bold fs-2">Criminal Sentencing</h1>
                        <h1 class="fw-bold fs-2">Simplified.</h1>

                    </div>
                </div>
            </div>
            
        </div>
        <div id="dark-blue" >
            <div class="d-flex justify-content-evenly p-5 w-100">
                <div class="col-3"></div>
                <div class="d-flex flex-column pr-5 mr-5 pl-5">
                    <div class="d-flex align-items-center mb-3">
                        <i class="fa fa-circle-check fs-1 mr-5"></i>
                        <div class="d-flex flex-column">
                            <h3 class="fs-4 fw-bold">Sentence</h3>
                            <p class="fs-5">Calculate exposure and lawful </br>sentences instantly</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center mb-3">
                        <i class="fa fa-circle-check fs-1 mr-5"></i>
                        <div class="d-flex flex-column">
                            <h3 class="fs-4 fw-bold">Jury Instructions</h3>
                            <p class="fs-5">View applicable CALCRIM </br>jury instructions</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center mb-3">
                        <i class="fa fa-circle-check fs-1 mr-5"></i>
                        <div class="d-flex flex-column">
                            <h3 class="fs-4 fw-bold">Credits</h3>
                            <p class="fs-5">Calculate custody credits and </br>release dates</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center mb-3">
                        <i class="fa fa-circle-check fs-1 mr-5"></i>
                        <div class="d-flex flex-column">
                            <h3 class="fs-4 fw-bold">Probation</h3>
                            <p class="fs-5">Determine probation eligibility</p>
                        </div>
                    </div>
                    
                    <div class="d-flex align-items-center mb-3">
                        <i class="fa fa-circle-check fs-1 mr-5"></i>
                        <div class="d-flex flex-column">
                            <h3 class="fs-4 fw-bold">Search</h3>
                            <p class="fs-5">Powerful crime search capabilities</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <i class="fa fa-circle-check fs-1 mr-5"></i>
                        <div class="d-flex flex-column">
                            <h3 class="fs-4 fw-bold">Reports</h3>
                            <p class="fs-5">Generate informative PDFs</p>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>

    </div>
</template>
<script>
export default {
  name: "LoginHero",
};
</script>
<style scoped>
#light-blue {
    background-color: #e6f4ff !important;
    height: 40vh;
    display: flex;
    justify-content: center;
}
#dark-blue {
    background-color: var(--button);
    height: 60vh;
    color: white !important;
}
#hero {
    width: 25vw;
    height: 25vw;
    position: absolute;
    top: calc(35vh - 125px);
    left: 40px;
}
@media (max-width: 1300px) {
    #hero, #hero-img {
        width: 20vw;

    }
}
/* #blue-circle {
    width: 25vw;
    height: 25vw;
    border-radius: 50%;
    background-color: var(--button);
    display: block
} */
#hero-img {
    margin-top: 60px;
    margin-left: 20px;
    width: 25vw;
}


</style>